import React from 'react';
import classNames from 'classnames';
import { withStyles, SnackbarContent } from './../../../../themes/default';
import { IconButton} from './../../../../themes/button';
import { CloseIcon, ErrorIcon, InfoIcon, WarningIcon, CheckCircleIcon } from './../../../../themes/icons';
import { green, amber } from './../../../../themes/colors';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles = theme => ({
  root:    { boxShadow: 'none', borderRadius: theme.spacing.unit / 2 },
  success: { backgroundColor: green[600] },
  error:   { backgroundColor: theme.palette.error.dark },
  info:    { backgroundColor: theme.palette.primary.dark },
  warning: { backgroundColor: amber[700] },
  icon:    { fontSize: 20 },
  iconVariant: { opacity: 0.9, marginRight: theme.spacing.unit },
  message: { display: 'flex', alignItems: 'center', flex: 1 }
});

class SnackbarStatic extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      open: false
    };
  }

  /*
  ** @DidMount
  */

  componentDidMount(){
    this.setState({ open: this.props.open });
  }

  /*
  ** @Event
  ** @Description: Close Snackbar
  */

  handleClose = (event, reason) => {
    this.setState({ open: false });
  };

  render() {

    const { classes, variant, message, icon, fullWidth, spacingBottom, hideClose } = this.props;
    const Variant = variant ? variant : 'info';
    let Icon;

    if(icon){
      Icon = variantIcon[icon];
    }

    return (
        this.state.open && (
          <SnackbarContent
            className={classNames(classes.root, classes[Variant])}
            classes={ {message: classes.message}  }
            message={
              <span className={ classes.message }>
                {Icon && (
                  <Icon className={classNames( classes.icon, classes.iconVariant )} />
                )}
                { message }
              </span>
            }
            action={
              !hideClose && (
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  className={ classes.close }
                  onClick={ this.handleClose }
                >
                  <CloseIcon className={classes.icon} />
                </IconButton>
              )
            }
            style={{ maxWidth: fullWidth ? '100%' : 'auto', marginBottom: spacingBottom ? spacingBottom : 0 }}
          />
        )
    )
  }

}

export default withStyles(styles)(SnackbarStatic);
